import { useAppSelector } from '@/store/hooks';

import {
  canWorkspaceAction,
  type WorkspacePermissionAction,
  type WorkspacePermissionResource,
} from '../selectors/permissions';

export function useCanWorkspaceAction(
  resource: WorkspacePermissionResource,
  action: WorkspacePermissionAction,
  fallback = false,
): boolean {
  const currentWorkspace = useAppSelector(
    (state) => state.workspaces.currentWorkspace,
  );

  return canWorkspaceAction(currentWorkspace, resource, action, fallback);
}
